import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { getExternalAgenciesApi } from './getExternalAgencies.api'
import getExternalAgenciesInitialState from './getExternalAgencies.initialState'
import { GetExternalAgenciesErrorResponse, GetExternalAgenciesRequestPayload } from './getExternalAgencies.types'

export const getExternalAgencies = createAsyncThunk(
  urls.flights.agencies,
  async (payload: GetExternalAgenciesRequestPayload, { rejectWithValue }) => {
    const { onSuccess } = payload

    try {
      const response = await getExternalAgenciesApi()

      onSuccess && onSuccess(response.data)

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getExternalAgenciesSlice = createSlice({
  name: urls.flights.agencies,
  initialState: getExternalAgenciesInitialState,
  reducers: {
    resetGetExternalAgencies: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExternalAgencies.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getExternalAgencies.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getExternalAgencies.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetExternalAgenciesErrorResponse
        state.success = null
      })
  }
})

export const { actions: getExternalAgenciesActions, reducer: getExternalAgenciesReducer } = getExternalAgenciesSlice
export const { resetGetExternalAgencies } = getExternalAgenciesActions
export default getExternalAgenciesSlice.reducer
